import type { ReactNode } from "react"
import { enterTerminal } from "../lib/handoff"

interface CTAProps {
  children?: ReactNode
  display?: boolean
}

export function CTA({ children = "ENTER TERMINAL", display = false }: CTAProps) {
  return (
    <button className={`cta mono${display ? " display" : ""}`} onClick={enterTerminal}>
      {children} <span aria-hidden="true">-&gt;</span>
    </button>
  )
}
